<div class="d-flex align-items-center profile">
  <button #button class="p-0 btn" (click)="open(content)">
    <img src="assets/image/profile.svg" />
  </button>
</div>

<ng-template #content let-offcanvas>
  <div class="profile-menu-wrapper">
    <div class="offcanvas-header">
      <div class="d-flex flex-column">
        <div class="profile-label">{{ 'NAME' | translate }}</div>
        <div>{{ (user$ | async)?.firstName }} {{ (user$ | async)?.lastName }}</div>
      </div>

      <div class="d-flex flex-column">
        <div class="profile-label">{{ 'EMAIL' | translate }}</div>
        <div>{{ (user$ | async)?.email }}</div>
      </div>

      <ng-container *ngIf="isEmea && trainingStatus">
        <div class="d-flex flex-column">
          <div class="profile-label">{{ 'Enrolled on' | translate }}</div>
          <div>
            {{ trainingStatus.enrollmentDate ? (trainingStatus.enrollmentDate | localisedDate : 'mediumDate') : '-' }}
          </div>
        </div>
        <div class="d-flex flex-column training-status-section">
          <hr class="header-divider" />
          <div class="profile-label">{{ 'Mandatory Training' | translate }}</div>
          <div class="mt-1 d-flex justify-content-between">
            <span class="training-label">{{ 'Training Status' | translate }}</span>
            <span>{{ trainingStatus.trainingStatus | translate }}</span>
          </div>
          <div
            class="mt-1 d-flex justify-content-between"
            *ngIf="trainingStatus.trainingDueDate && trainingStatus.trainingStatus !== 'Completed'"
          >
            <span class="training-label">{{ 'Due By' | translate }}</span>
            <span>{{ trainingStatus.trainingDueDate | localisedDate : 'mediumDate' }}</span>
          </div>
          <div class="mt-1 d-flex justify-content-between" *ngIf="trainingStatus.completedOn">
            <span class="training-label">{{ 'Completed On' | translate }}</span>
            <span>{{ trainingStatus.completedOn | localisedDate : 'mediumDate' }}</span>
          </div>
          <div class="mt-1 d-flex justify-content-between" *ngIf="trainingStatus.completedByEmail">
            <span class="training-label completed-by-label">{{ 'Completed by' | translate }}</span>
            <span class="text-truncate completed-by-email" [title]="trainingStatus.completedByEmail">{{
              trainingStatus.completedByEmail
            }}</span>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="offcanvas-body main">
      <div class="d-flex flex-column">
        <div class="h-100 d-flex align-items-center">
          <a class="logout" (click)="logOut()">
            <fa-icon [icon]="['fas', 'arrow-right-from-bracket']"></fa-icon>
            <span>{{ 'Log out' | translate }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="widgets">
      <hr />
      <app-account-summary-widget></app-account-summary-widget>
      <hr />
      <app-cart-widget></app-cart-widget>
    </div>
  </div>
</ng-template>
